var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFireIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FDFCC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1603 20.1968C33.0539 20.1095 32.9277 20.0487 32.7924 20.0196C32.6572 19.9905 32.5168 19.9939 32.3831 20.0294C32.2494 20.065 32.1264 20.1318 32.0244 20.2241C31.9223 20.3165 31.8443 20.4316 31.7969 20.5599L29.4219 26.9925L26.8137 24.4998C26.7261 24.416 26.6215 24.3514 26.5068 24.3104C26.3921 24.2694 26.2698 24.2528 26.1482 24.2618C26.0265 24.2707 25.9081 24.305 25.8008 24.3624C25.6935 24.4197 25.5998 24.4988 25.5258 24.5945C23.1875 27.6165 22 30.6566 22 33.6296C22 36.1148 23.0009 38.4982 24.7825 40.2555C26.5641 42.0128 28.9804 43 31.5 43C34.0196 43 36.4359 42.0128 38.2175 40.2555C39.9991 38.4982 41 36.1148 41 33.6296C41 27.2992 35.517 22.1295 33.1603 20.1968ZM37.5336 34.6241C37.3096 35.8579 36.7078 36.9944 35.8092 37.8807C34.9105 38.7669 33.7581 39.3602 32.5072 39.5809C32.4598 39.5889 32.4118 39.5928 32.3636 39.5926C32.147 39.5925 31.9383 39.5122 31.7789 39.3674C31.6195 39.2227 31.5211 39.0242 31.5032 38.8112C31.4853 38.5983 31.5491 38.3865 31.6821 38.2178C31.8151 38.0491 32.0075 37.9359 32.2211 37.9006C34.0099 37.6035 35.5278 36.1063 35.8311 34.3387C35.8695 34.1159 35.996 33.9173 36.1829 33.7865C36.3698 33.6557 36.6017 33.6034 36.8276 33.6413C37.0535 33.6791 37.2549 33.8039 37.3875 33.9882C37.5201 34.1726 37.573 34.4013 37.5347 34.6241H37.5336Z",
    fill: "#9C9B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireIcon);
export default __webpack_public_path__ + "static/media/fire-icon.72b05cb583ea224c8eacd050c818d1d1.svg";
export { ForwardRef as ReactComponent };